import React, { useContext, useEffect, useState } from "react";
import InputForm from "../../Components/InputForm/InputForm";
import DateForm from "../../Components/DateForm/DateForm";
import SelectForm from "../../Components/SelectForm/SelectForm";
import { SettlementDetailsById } from "../../Helpers/APIEndPoints/EndPoints";
import { APICall, HttpMethod } from "../../Helpers/Network/APICalls";
import ButtonComponent from "../../Components/ButtonForm/Button";
import { useNavigate } from "react-router-dom";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { LoanTypeEnum } from "../../Helpers/Enums/Enum";
import moment from "moment";
import { downloadBlob } from "../../Helpers/Common/BlobHelper";
import ImageViewer from "../../Components/ImageViewer/ImageViewer";
import SettlementStatus, { SettlementModule } from "./SettlementStatus";

const StlmtPersonalDetails = (props) => {
  // const { Status, selectNextTab } = props;
  let navigate = useNavigate();
  const context = getContext();
  const [fName, setFName] = useState("");
  const [midName, setMidName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dob, setDOB] = useState("");
  const [doC, setDOC] = useState("");
  const [doj, setDOJ] = useState("");
  const [RejectedRemarks, setRejectedRemarks] = useState("");
  const [reasonOfRequest, setReasonOfRequest] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [bankName, setBankName] = useState("");
  const [MemberNo, setMemberNo] = useState(0);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [images, setImages] = useState([]);
  const [PDFFiles, setPDFFiles] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [showImageViewer, setShowImageViewer] = useState<boolean>(false);
  const [imageIndex, setImageIndex] = useState<number>(null);

  const StateCurrentStatus = props.statecurrentstatus;
  const StateSetId = props.statesetid;
  const StateMemberId = props.statememberid;
  const StateMode = props?.mode;

  useEffect(() => {
    SettlementDetails();
  }, []);

  useEffect(() => {
    if (imageIndex !== null) {
      setShowImageViewer(true);
    }
  }, [imageIndex]);

  const maskSensitiveData = (data) => {
    // Convert data to string

    let dataString = data?.toString();

    // Check if data has more than 4 characters
    if (dataString.length > 4) {
      // Mask all but the last 4 characters
      let maskedPart = "X".repeat(dataString.length - 4);
      let visiblePart = dataString.slice(-4);
      return maskedPart + visiblePart;
    } else {
      // If data has 4 or fewer characters, return as is
      return dataString;
    }
  };

  const SettlementDetails = async () => {
    showLoader();
  
    const requestData1 = {
      SetId: StateSetId,
      MemberId: StateMemberId,
    };

    const res = await APICall(SettlementDetailsById, requestData1);
    if (res.Data && Object.keys(res.Data).length > 0) {
      let i = 0;
      setRejectedRemarks("Rejected");
      setFName(res?.Data?.[i]?.FirstName);
      setMidName(res?.Data?.[i]?.MiddleName);
      setLastName(res?.Data?.[i]?.LastName);
      setDOB(
        moment(res?.Data?.[i]?.DOB, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD")
      );
      setDOC(
        moment(res?.Data?.[i]?.DOC, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD")
      );
      setDOJ(
        moment(res?.Data?.[i]?.DOJ, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD")
      );
      // setDOB(res?.Data?.[i]?.DOB);
      // setDOC(res?.Data?.[i]?.DOC);
      // setDOJ(res?.Data?.[i]?.DOJ);
      setAccountNumber(maskSensitiveData(res?.Data?.[i]?.Mkd_AccountNo));
      setBankName(maskSensitiveData(res?.Data?.[i]?.Mkd_BankName));
      setReasonOfRequest(res?.Data?.[i]?.Reason);
      setMemberNo(res?.Data?.[i]?.MemberNo);
      // setFileNameData(res?.Data?.[i]?.FileName.split(","));
      // setFileTypeData(res?.Data?.[i]?.FileType.split(","));
      // setFileURLData(res?.Data?.[i]?.FileUrl.split(","));
      // Split FileName string

      let fileNames = [];
      let fileTypes = [];
      let fileUrls = [];
      if (res?.Data?.[i]?.IsAdmin) {
        fileNames = res?.Data?.[i]?.InternalTeamFileName?.split(",");
        fileTypes = res?.Data?.[i]?.InternalTeamFileType?.split(",");
        fileUrls = res?.Data?.[i]?.InternalTeamFileUrl?.split(",");
      } else {
        fileNames = res?.Data?.[i]?.FileName?.split(",");
        fileTypes = res?.Data?.[i]?.FileType?.split(",");
        fileUrls = res?.Data?.[i]?.FileUrl?.split(",");
      }

      let newDocuments = [];
      if (fileUrls?.length > 0) {
        for (let i = 0; i < fileUrls.length; i++) {
          let fileUrl = await downloadBlob(fileUrls[i]);
          let fileType = fileTypes[i]?.toLowerCase()?.endsWith("pdf")
            ? "pdf"
            : "image";

          newDocuments.push({
            src: fileUrl,
            title: fileNames[i],
            type: fileType,
          });
        }
      }
      setDocuments(newDocuments);

      // let newImages = [];
      // let newPDFFiles = []; // Array to hold PDF files
      // if (fileUrls?.length > 0) {
      //   for (let i = 0; i < fileUrls.length; i++) {
      //     // Download blob
      //     let imgUrl = await downloadBlob(fileUrls[i]);

      //     // Determine file type
      //     let fileType = fileTypes[i]?.toLowerCase()?.endsWith("pdf")
      //       ? "pdf"
      //       : "image";

      //     // Push downloaded blob into newImages array
      //     if (fileType === "pdf") {
      //       // If the file is a PDF, push it into the newPDFFiles array
      //       newPDFFiles.push({
      //         src: imgUrl,
      //         title: fileNames[i],
      //       });
      //     } else {
      //       // Otherwise, push it into the newImages array
      //       newImages.push({
      //         src: imgUrl,
      //         title: fileNames[i],
      //       });
      //     }
      //   }
      // }

      // // Set the PDF files in state
      // setPDFFiles(newPDFFiles);

      // // Set newImages array in state
      // setImages(newImages);
    }
    hideLoader();
  };

  const handleDocumentClick = (doc, index) => {
    if (doc?.type === "pdf") {
      window.open(doc.src, "_blank");
    } else {
      setImageIndex(0);
      setShowImageViewer(true);
    }
  };

  const chunkArray = (array, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };

  const DocumentList = ({ documents }) => {
    const documentChunks = chunkArray(documents, 5);

    return (
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {documentChunks.map((chunk, chunkIndex) => (
          <ul
            key={chunkIndex}
            style={{ listStyleType: "circle", paddingLeft: "30px" }}
          >
            {chunk.map((doc, index) => (
              <li key={index} style={{ listStyleType: "circle" }}>
                <p
                  onClick={() => {
                    if (doc?.type === "pdf") {
                      window.open(doc.src, "_blank");
                    } else {
                      setImageIndex(0);
                      setShowImageViewer(true);
                    }
                    // handleDocumentClick(doc, index + chunkIndex * 5)
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {doc.title}
                </p>
              </li>
            ))}
          </ul>
        ))}
      </div>
    );
  };

  return (
    <>
      <div className="row ">
        <div className="col-lg-12 text-center mb-2">
          <h5>Member Number:{MemberNo}</h5>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-6">
          <div className="form-group"></div>
          <label>First Name</label>
          <InputForm
            placeholder={""}
            value={fName}
            isDisabled={true}
            maxLength={30}
          />
        </div>
        <div className="col-lg-4 col-md-4 col-sm-6">
          <div className="form-group"></div>
          <label>Middle Name</label>
          <InputForm
            placeholder={""}
            value={midName}
            isDisabled={true}
            maxLength={30}
          />
        </div>
        <div className="col-lg-4 col-md-4 col-sm-6">
          <div className="form-group"></div>
          <label>Last Name</label>
          <InputForm
            placeholder={""}
            value={lastName}
            isDisabled={true}
            maxLength={30}
          />
        </div>

        <div className="col-lg-4 col-md-4 col-sm-6">
          <div className="form-group"></div>
          <label>Date of Birth</label>
          <DateForm
            value={dob}
            onChange={(event: any) => alert()}
            placeholder="DD-MM-YYYY"
            isDisabled={true}
          />
        </div>
        <div className="col-lg-4 col-md-4 col-sm-6">
          <div className="form-group"></div>
          <label>Date of confirmation</label>
          <DateForm
            value={doC}
            onChange={(event: any) => alert()}
            placeholder="DD-MM-YYYY"
            isDisabled={true}
          />
        </div>
        <div className="col-lg-4 col-md-4 col-sm-6">
          <div className="form-group"></div>
          <label>Reason of Request</label>
          <InputForm
            placeholder={""}
            value={reasonOfRequest}
            isDisabled={true}
            maxLength={30}
          />
        </div>

        <div className="col-lg-4 col-md-4 col-sm-6">
          <div className="form-group"></div>
          <label>Date of Joining</label>
          <DateForm
            value={doj}
            onChange={(event: any) => alert()}
            placeholder="DD-MM-YYYY"
            isDisabled={true}
          />
        </div>
        <div className="col-lg-4 col-md-4 col-sm-6">
          <div className="form-group"></div>
          <label>Bank Account Number</label>
          <InputForm placeholder={""} value={accountNumber} isDisabled={true} />
        </div>
        <div className="col-lg-4 col-md-4 col-sm-6">
          <div className="form-group"></div>
          <label>Bank Name</label>
          <InputForm placeholder={""} value={bankName} isDisabled={true} />
        </div>
        {/* <div
          className="col-lg-2 col-sm-2 col-xs-2"
          style={{ marginTop: "10px" }}
        >
          <div
            className="form-control"
            style={{ border: "none", order: "none" }}
          >
            <label className="view_eye pe-pointer">Attached Documents</label>
          </div>
        </div> */}

        <div
          className="col-lg-4 col-sm-4 col-xs-4"
          style={{ marginTop: "10px" }}
        >
          {documents?.length > 0 && (
            <>
              <label className="view_eye pe-pointer">Attached Documents: </label>
              <DocumentList documents={documents} />
              {/* <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                {documents.map((doc, index) => (
                  <li key={index} style={{ listStyleType: "circle" }}>
                    <p
                      onClick={() => handleDocumentClick(doc, index)}
                      style={{ cursor: "pointer" }}
                    >
                      {doc.title}
                    </p>
                  </li>
                ))}
              </ul> */}

              {showImageViewer && (
                <ImageViewer
                  open={showImageViewer}
                  images={documents.filter((doc) => doc?.type === "image")}
                  imageIndex={imageIndex}
                  onClose={() => {
                    setShowImageViewer(false);
                    setImageIndex(null);
                  }}
                />
              )}
            </>
          )}
        </div>
      </div>
      {/* <div className="col-lg-4 col-md-4 col-sm-6">
          <div
            className="form-control"
            style={{
              border: "none",
              order: "none",
            }}
          >
            <label className="view_eye pe-pointer">Attached Documents</label>
            {"   "}
            <i
              className="fa fa-eye pe-pointer"
              aria-hidden="true"
              onClick={() => {
                setImageIndex(0);
              }}
            ></i>
          </div>
          {images && images.length > 0 && (
            <ImageViewer
              open={showImageViewer}
              images={images}
              imageIndex={imageIndex}
              onClose={() => setShowImageViewer(false)}
            />
          )}
        {/* </div>
        <div className="col-lg-4 col-md-4 col-sm-6"> *}
          {PDFFiles && PDFFiles.length > 0 && (
            <>
              {PDFFiles.map((pdf, index) => (
                <div
                  className="form-control"
                  style={{
                    border: "none",
                    order: "none",
                  }}
                  key={index}
                >
                  <div
                    onClick={() => {
                      window.open(pdf.src, "_blank");
                    }}
                  >
                    <label className="view_eye pe-pointer">
                      Pdf Files: {pdf.title}
                    </label>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
      */}
    </>
  );
};

export default StlmtPersonalDetails;
